<template>
  <div style="width: 100%; height:100%">
    <a-list :grid="{ gutter: gutter, column: column }" :data-source="list">
      <a-list-item slot="renderItem" slot-scope="item, index" :key="index">
        <div class="ab-features-item">
          <img :src="require(`@/assets/images/product/${item.icon_url}`)" />
          <div class="title fontsize20">
            {{ item.title }}
          </div>
          <div class="desc fontsize16">
            {{ item.desc }}
          </div>
        </div>
      </a-list-item>
    </a-list>
    <!-- <div class="ab-features-list" v-for="item in list" :key="item.id">
      <img :src="`${iconUrlBase}${item.icon_url}`" />
      <div class="title">
        {{ item.title }} 
      </div>
      <div class="desc">
        {{ item.desc }}
      </div>
    </div> -->
  </div>
</template>

<script>
// import jsjz from '~@/assets/product/icon_0基础极速建站.png';
export default {
  props: {
    urlBase: {
      type: String,
      // default: '~@/assets/product/',
      // default: '/public/product/',
    },
    dataList: {
      type: Array,
      default: [],
    },
    columnVal: {
      type: String,
      default: '3',
    },
    gutterVal: {
      type: Number,
      default: 50,
    },
    widthVar: {
      type: String,
      default: '400px',
    },
  },
  data: function() {
    return {
      iconUrlBase: this.urlBase,
      list: this.dataList,
      column: this.columnVal,
      gutter: this.gutterVal,
      itemWidth: this.widthVar, // item 的宽度
    };
  },
};
</script>

<style lang="sass">
.ab-features-item{
  padding: 10px 0px;
  text-align: center;
  .title{
    height: 27px;
    font-family: AlibabaPuHuiTiM;
    font-weight: normal;
    color: #333646;
    line-height: 27px;
  }

  .desc{
    width: 78%;
     min-height: 97px;
    margin: 10px auto 30px ;
    font-family: Alibaba-PuHuiTi-R;
    font-weight: normal;
    color: rgba(51,51,51,0.8);
    line-height: 32px;
  }

  img{
   margin-bottom:20px;
   max-width:100%;
   width: 90px;
  }
}
</style>
